import * as types from './constants'

const initialState = {
    isReadyToPay: false,
    pending: false,
    error: null,
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case types.GOOGLE_PAY_INIT_READY_TO_PAY:
            return { ...state, pending: true, error: null }

        case types.GOOGLE_PAY_READY_TO_PAY_SUCCESS:
            return { ...state, pending: false, isReadyToPay: action.isReadyToPay }
        case types.GOOGLE_PAY_READY_TO_PAY_FAILURE:
            return { ...state, pending: false, error: action.error, isReadyToPay: false }

        default:
            return state
    }
}
